export const checkWarningStatus = (item: any, progressData: any) => {
  if (item.title === 'User Management' && !progressData?.firmProfileProgress?.manageFirmRoles) return true;
  if (item.title === 'Advice Templates' && !progressData?.firmProfileProgress?.adviceTemplates) return true;
  if (item.title === 'Risk Assessment' && !progressData?.firmProfileProgress?.riskAssessment) return true;
  if (item.title === 'Financial Planning' && !progressData?.firmProfileProgress?.financialPlanning) return true;
  if (item.title === 'Fact Find' && !progressData?.firmProfileProgress?.factFindFieldConfig) return true;
  return false;
};
